import React from "react";
import AiInProgressImg from './assets/img/builde_ai.png';

export const Header = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>{props.data?.title}</h2>
          <div className="service-desc">
            <h3>{props.data?.subTitle}</h3>
          </div>
          <div className="ai-banner-containter">
            <img src={ AiInProgressImg }/>
          </div>
          {
            props.data?.paragraphs
              ? props.data.paragraphs.map((d, i) => (
                <p key={`paragraph-${i}`}>
                  {d}
                </p>
              ))
              : "Loading..."
          }
        </div>
      </div>
    </div>
  );
};
